<script setup lang="ts">
import DolphinRadioButton from '@/components/atoms/DolphinRadioButton.vue'
import {
  LineRichMenuFormStatusPublished,
  LineRichMenuFormStatusUnpublished,
  type LineRichMenuFormStatusType,
} from './formSchema'

const model = defineModel<LineRichMenuFormStatusType>({ required: true })

const statusOptions = [
  {
    type: 'published',
    label: '公開',
    handler: () => {
      model.value = LineRichMenuFormStatusPublished
    },
  },
  {
    type: 'unpublished',
    label: '非公開',
    handler: () => {
      model.value = LineRichMenuFormStatusUnpublished
    },
  },
] as const
</script>

<template>
  <section>
    <p :class="$style.sectionTitle">ステータス</p>
    <div :class="$style.sectionContent">
      <div :class="$style.optionsWrapper">
        <label
          v-for="status of statusOptions"
          :key="status.type"
          :class="$style.option"
        >
          <DolphinRadioButton
            name="status"
            :value="status.type"
            :modelValue="model"
            @update:modelValue="status.handler"
          />
          <span :class="$style.option__text">
            {{ status.label }}
          </span>
        </label>
      </div>
    </div>
  </section>
</template>

<style module lang="scss">
.sectionTitle {
  font-size: 18px;
  font-weight: bold;
}

.sectionContent {
  margin-top: 16px;
}

.optionsWrapper {
  display: flex;
  gap: 24px;
}

.option {
  display: inline-flex;
  align-items: center;

  &__text {
    font-size: 14px;

    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}

.customTargetSetting {
  margin-top: 16px;
}
</style>
